import ApiClient from './ApiClient';

// Surfaces backend structured errors ({ error: "..." }) — mirrors TasksClient/ColoClient.
const extractErrorMessage = (error, fallback) =>
  error?.response?.data?.error || error?.message || fallback;

// DTO items serialize PascalCase; wrapper keys (announcements/announcement) are camelCase.
// Normalize at the client boundary, same as ColoClient.
const toCamelKey = key => key.charAt(0).toLowerCase() + key.slice(1);

const toCamelCaseShallow = obj => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [toCamelKey(key), value])
  );
};

const toCamelCaseArray = arr => (arr ?? []).map(toCamelCaseShallow);

class AnnouncementsClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}/announcements` : '/announcements');
  }

  async getAnnouncements() {
    try {
      const data = await this.get('');
      return toCamelCaseArray(data?.announcements);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to fetch announcements.')
      );
    }
  }

  // body: { title, message, linkUrl?, enabled, startsAt?, endsAt? }
  async createAnnouncement(body) {
    try {
      const data = await this.post('', body);
      return toCamelCaseShallow(data?.announcement);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to create announcement.')
      );
    }
  }

  // body: subset of { title, message, linkUrl, clearLinkUrl, enabled, startsAt, clearStartsAt,
  // endsAt, clearEndsAt } — omitted fields unchanged.
  async updateAnnouncement(id, body) {
    try {
      const data = await this.patch(`/${id}`, body);
      return toCamelCaseShallow(data?.announcement);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to update announcement.')
      );
    }
  }

  async deleteAnnouncement(id) {
    try {
      await this.delete(`/${id}`);
    } catch (error) {
      throw new Error(
        extractErrorMessage(error, 'Failed to delete announcement.')
      );
    }
  }
}

export default AnnouncementsClient;
